var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Google_svg__[object_Object]a",
    d: "M21.923 9.23H11.077v4.616h6.461c-.566 2.832-3.06 4.51-6.203 4.51-3.71 0-6.698-3.041-6.698-6.818 0-3.776 2.988-6.818 6.698-6.818 1.597 0 3.04.577 4.173 1.521l3.297-3.356C16.795 1.1 14.22 0 11.335 0 5.049 0 0 5.14 0 11.538c0 6.4 5.049 11.539 11.335 11.539 5.667 0 10.819-4.196 10.819-11.539 0-.681-.076-1.625-.23-2.307z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.923)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Google_svg__[object_Object]b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Google_svg__[object_Object]a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "nonzero",
    mask: "url(#Google_svg__[object_Object]b)",
    d: "M-1.03 18.357L14.426 6.294l4.07.524 5.203-7.867v25.175H-1.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "nonzero",
    mask: "url(#Google_svg__[object_Object]b)",
    d: "M23.699 24.126L7.728 11.538 5.667 9.965 23.699 4.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "nonzero",
    mask: "url(#Google_svg__[object_Object]b)",
    d: "M-1.03 4.72l8.758 6.818 3.607-3.199 12.364-2.045v-7.343H-1.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "nonzero",
    mask: "url(#Google_svg__[object_Object]b)",
    d: "M-1.03 18.357V4.72l8.758 6.818z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default ForwardRef;